<fury-page>
  <fury-title class="title">
      <h2>{{partnerId ? 'Update': 'Add'}} lead partner</h2>
  </fury-title>
</fury-page>

<div fxLayout="column" fxLayoutAlign="start center">
  <div [@fadeInUp] class="card">
    <form [formGroup]="partnerForm">
      <div class="content" fxLayout="column" fxLayoutGap="8px">
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Partner Name</mat-label>
            <input matInput placeholder="Title" formControlName="title">
            <mat-error
              *ngIf="partnerForm.controls['title'].touched && partnerForm.controls['title'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Utm source</mat-label>
            <input matInput placeholder="Utm source" formControlName="utmSource">
            <mat-error
              *ngIf="partnerForm.controls['utmSource'].touched && partnerForm.controls['utmSource'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Select Partner Type</mat-label>
            <mat-select formControlName="type">
              <mat-option value="affiliate"> Affiliate </mat-option>
              <mat-option value="email"> Email </mat-option>
              <mat-option value="print"> Print </mat-option>
              <mat-option value="referral"> Referral </mat-option>
              <mat-option value="search"> Search </mat-option>
              <mat-option value="social"> Social </mat-option>
              <mat-option value="tv"> TV </mat-option>
            </mat-select>
            <mat-error *ngIf="partnerForm.get('type')?.touched && partnerForm.get('type')?.hasError('required')">
              This is a required field.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input placeholder="Phone Number" type="text" mask="(000) 000-0000" formControlName="phoneNumber"
              matInput>
            <mat-error
              *ngIf="partnerForm.controls['phoneNumber'].touched && partnerForm.controls['phoneNumber'].hasError('required')">
              This is a required field.</mat-error>
            <mat-error
              *ngIf="partnerForm.controls['phoneNumber'].hasError('pattern') && !partnerForm.controls['phoneNumber'].hasError('required')">
              Enter a valid phone number</mat-error>
              <mat-error
              *ngIf="partnerForm.controls['phoneNumber'].touched && partnerForm.controls['phoneNumber'].hasError('notValid')">
              The phone number has already been taken.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Landing Page</mat-label>
            <mat-select formControlName="urlType">
              <mat-option value="offers"> Offers </mat-option>
              <mat-option value="estimates"> Estimates </mat-option>
            </mat-select>
            <mat-error *ngIf="partnerForm.get('urlType')?.touched && partnerForm.get('urlType')?.hasError('required')">
              This is a required field.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline" class="generatebtn">
            <mat-label>Api Key</mat-label>
            <input matInput placeholder="Api Key" formControlName="apiKey">
            <button type="button" matSuffix (click)="generateRandomApiKey()" *ngIf="!partnerId">
              GENERATE
            </button>
            <mat-error
              *ngIf="partnerForm.controls['apiKey'].touched && partnerForm.controls['apiKey'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Cpl</mat-label>
            <input matInput placeholder="Cpl" formControlName="cpl" (keypress)="isNumberKey($event)">
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Third Party Webhook Url</mat-label>
            <input matInput placeholder="thirdPartyWebhookUrl" formControlName="thirdPartyWebhookUrl">
            <mat-error
            *ngIf="partnerForm.controls['thirdPartyWebhookUrl'].touched && partnerForm.controls['thirdPartyWebhookUrl'].hasError('pattern')">
            Enter a valid Url.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Source</mat-label>
            <input matInput placeholder="Source" type="text" formControlName="referralAbbreviation">
            <mat-error
            *ngIf="partnerForm.controls['referralAbbreviation'].touched && partnerForm.controls['referralAbbreviation'].hasError('required')">
            This is a required field.</mat-error>
            <mat-error
            *ngIf="partnerForm.controls['referralAbbreviation'].touched && partnerForm.controls['referralAbbreviation'].hasError('minlength')">
            Minimum length should be 3.</mat-error>
            <mat-error
            *ngIf="partnerForm.controls['referralAbbreviation'].touched && partnerForm.controls['referralAbbreviation'].hasError('maxlength')">
            Maximum length should be 7.</mat-error>
          </mat-form-field>

         
        </div>
        <fxLayout fxLayout="column" fxLayout.gt-sm="row"
        style="margin-bottom: 20px;align-items: baseline;">
        <span style="margin-right: 10px;"><input type="radio" [value]="true" (change)="changeLead($event)"  formControlName="isWebLead"> Web Lead</span>
        <span><input type="radio" [value]="false" (change)="changeLead($event)"  formControlName="isWebLead"> Post Lead</span>
      
        </fxLayout>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Scripts</mat-label>
          <textarea matInput placeholder="Scripts" formControlName="scripts"></textarea>
          <mat-error
            *ngIf="partnerForm.controls['scripts'].touched && partnerForm.controls['scripts'].hasError('required')">
            This is a required field.</mat-error>
            <mat-error
            *ngIf="partnerForm.controls['scripts'].touched && partnerForm.controls['scripts'].hasError('pattern')">
            {{scriptMessage}}
           </mat-error>
        </mat-form-field>


          
      </div>
     
    </form>

    <!-- Dummy Url Generate -->
    <p *ngIf="partnerForm.controls['utmSource'].value">Url: {{'https://www.elitehw.com/' + partnerForm.controls['urlType'].value.toLowerCase() +'?utm_source=' +
      partnerForm.controls['utmSource'].value.toLowerCase() + (partnerForm.get('type')?.value ? '&medium='+ partnerForm.get('type')?.value : '') + 
      (( partnerForm.controls['data'].get('subId')?.value?.type === 'third-party') ? '&subid=' : '') +
      (( partnerForm.controls['data'].get('clickId')?.value?.type === 'third-party') ? '&clickid=' : '') +
      (( partnerForm.controls['data'].get('traffic')?.value?.type === 'third-party') ?  '&traffictype=' : '') + 
      (( partnerForm.controls['data'].get('keyword')?.value?.type === 'third-party') ? '&keyword=' : '') +
      (( partnerForm.controls['data'].get('position')?.value?.type === 'third-party') ? '&position=' : '') + 
      (( partnerForm.controls['data'].get('gclid')?.value?.type === 'third-party') ? '&gclid=' : '') + 
      (( partnerForm.controls['data'].get('fbclid')?.value?.type === 'third-party') ? '&fbclid=' : '') +
      (( partnerForm.controls['data'].get('msclkid')?.value?.type === 'third-party') ? '&msclkid=' : '') + 
      (( partnerForm.controls['data'].get('twclid')?.value?.type === 'third-party') ? '&twclid=' : '')
      }}
    </p>

    <ul style="padding: 0;">
      <mat-checkbox style="margin: 16px" [checked]="parameter.subId" (change)="updateValue('subId', $event)">Sub Id {{ partnerForm.controls['data'].get('subId')?.value?.type ? '(' +  (partnerForm.controls['data'].get('subId')?.value?.type | titlecase | caseTranformation) + ')' : ''}}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.clickId" (change)="updateValue('clickId', $event)">Click Id {{ partnerForm.controls['data'].get('clickId')?.value?.type ? '(' +  (partnerForm.controls['data'].get('clickId')?.value?.type | titlecase | caseTranformation) + ')' : ''}}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.traffic" (change)="updateValue('traffic', $event)">Traffic {{partnerForm.controls['data'].get('traffic')?.value?.type ? '(' + (partnerForm.controls['data'].get('traffic')?.value?.type | titlecase | caseTranformation) + ')' : ''}}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.keyword" (change)="updateValue('keyword', $event)">Keyword {{partnerForm.controls['data'].get('keyword')?.value?.type ? '(' + (partnerForm.controls['data'].get('keyword')?.value?.type | titlecase | caseTranformation) + ')' : ''}}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.position" (change)="updateValue('position', $event)">Position {{partnerForm.controls['data'].get('position')?.value?.type ? '(' + (partnerForm.controls['data'].get('position')?.value?.type | titlecase | caseTranformation)  + ')' : ''  }}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.gclid" (change)="updateValue('gclid', $event)">Gclid {{partnerForm.controls['data'].get('gclid')?.value?.type ? '(' + (partnerForm.controls['data'].get('gclid')?.value?.type | titlecase | caseTranformation) + ')' : '' }}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.fbclid" (change)="updateValue('fbclid', $event)">FBClid {{partnerForm.controls['data'].get('fbclid')?.value?.type ? '(' + (partnerForm.controls['data'].get('fbclid')?.value?.type | titlecase | caseTranformation) + ')' : '' }}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.msclkid " (change)="updateValue('msclkid', $event)">MSCLKID {{partnerForm.controls['data'].get('msclkid')?.value?.type ? '(' + (partnerForm.controls['data'].get('msclkid')?.value?.type | titlecase | caseTranformation) + ')' : '' }}</mat-checkbox>

      <mat-checkbox style="margin: 16px" [checked]="parameter.twclid " (change)="updateValue('twclid', $event)">TWclid {{partnerForm.controls['data'].get('twclid')?.value?.type ? '(' + (partnerForm.controls['data'].get('twclid')?.value?.type | titlecase | caseTranformation) + ')' : '' }}</mat-checkbox>
    </ul>

    <form [formGroup]="partnerForm" style="width: 100%; flex-direction:column;">
      <ng-container formGroupName="data">

          <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="subId"
            style="margin-bottom: 20px;align-items: baseline;" *ngIf="partnerForm.controls['data']?.get('subId')?.value?.type === 'static'">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Sub Id</mat-label>
              <input matInput placeholder="Sub Id"  formControlName="value">
              <mat-error
                *ngIf="partnerForm.controls['data']?.get('subId')?.get('value')?.touched && partnerForm.controls['data']?.get('subId')?.get('value')?.hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </fxLayout>
          <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="clickId"
            style="margin-bottom: 20px;align-items: baseline;" *ngIf="partnerForm.controls['data']?.get('clickId')?.value?.type === 'static'">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Click Id</mat-label>
              <input matInput placeholder="Click Id" formControlName="value">
              <mat-error
                *ngIf="partnerForm.controls['data']?.get('clickId')?.get('value')?.touched && partnerForm.controls['data']?.get('clickId')?.get('value')?.hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
          </fxLayout>
          <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="traffic"
            style="margin-bottom: 20px;align-items: baseline;" *ngIf="partnerForm.controls['data']?.get('traffic')?.value?.type === 'static'">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Traffic</mat-label>
                <input matInput placeholder="Traffic" formControlName="value">
                <mat-error
                  *ngIf="partnerForm.controls['data']?.get('traffic')?.get('value')?.touched && partnerForm.controls['data']?.get('traffic')?.get('value')?.hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
          </fxLayout>
          <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="keyword"
            style="margin-bottom: 20px;align-items: baseline;" *ngIf="partnerForm.controls['data']?.get('keyword')?.value?.type === 'static'">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Keyword</mat-label>
            <input matInput placeholder="Keyword" formControlName="value">
            <mat-error
              *ngIf="partnerForm.controls['data']?.get('keyword')?.get('value')?.touched && partnerForm.controls['data']?.get('keyword')?.get('value')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          </fxLayout>

          <ng-container formGroupName="position">
              <mat-form-field *ngIf="partnerForm.controls['data']?.get('position')?.value?.type === 'static'" style="width:100%;" appearance="outline">
                <mat-label>Position</mat-label>
                <input matInput placeholder="Position" formControlName="value">
                <mat-error
                  *ngIf="partnerForm.controls['data']?.get('position')?.get('value')?.touched && partnerForm.controls['data']?.get('position')?.get('value')?.hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
        </ng-container>

        <ng-container formGroupName="gclid">
          <mat-form-field *ngIf="partnerForm.controls['data']?.get('gclid')?.value?.type === 'static'" fxFlex="auto" appearance="outline" style="width:100%;">
            <mat-label>Gclid</mat-label>
            <input matInput placeholder="gclid" formControlName="value">
            <mat-error
              *ngIf="partnerForm.controls['data']?.get('gclid')?.get('value')?.touched && partnerForm.controls['data']?.get('gclid')?.get('value')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </ng-container>

        <ng-container formGroupName="fbclid">
          <mat-form-field *ngIf="partnerForm.controls['data']?.get('fbclid')?.value?.type === 'static'" style="width:100%;" appearance="outline">
            <mat-label>FBClid</mat-label>
            <input matInput placeholder="FBClid" formControlName="value">
            <mat-error
              *ngIf="partnerForm.controls['data']?.get('fbclid')?.get('value')?.touched && partnerForm.controls['data']?.get('fbclid')?.get('value')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
      </ng-container>

      <ng-container formGroupName="msclkid">
        <mat-form-field *ngIf="partnerForm.controls['data']?.get('msclkid')?.value?.type === 'static'" style="width:100%;" appearance="outline">
          <mat-label>MSCLKID</mat-label>
          <input matInput placeholder="MSCLKID" formControlName="value">
          <mat-error
            *ngIf="partnerForm.controls['data']?.get('msclkid')?.get('value')?.touched && partnerForm.controls['data']?.get('msclkid')?.get('value')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
    </ng-container>

    <ng-container formGroupName="twclid">
      <mat-form-field *ngIf="partnerForm.controls['data']?.get('twclid')?.value?.type === 'static'" style="width:100%;" appearance="outline">
        <mat-label>TWclid</mat-label>
        <input matInput placeholder="TWclid" formControlName="value">
        <mat-error
          *ngIf="partnerForm.controls['data']?.get('twclid')?.get('value')?.touched && partnerForm.controls['data']?.get('twclid')?.get('value')?.hasError('required')">
          This is a required field.</mat-error>
      </mat-form-field>
  </ng-container>
     
      </ng-container>
    </form>

    <form [formGroup]="partnerForm" style="width: 100%; flex-direction:column;">
      <div class="content" fxLayout="column" fxLayoutGap="8px">
        <ng-container formGroupName="restrictedHours">
          <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="sunday"
          style="margin-bottom: 20px;align-items: baseline;">
          <h3 class="weekdate">Sunday</h3>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Start Time</mat-label>
            <input
              type="text"
              matInput
              [ngxMatTimepicker]="timepicker"
              [format]="24"
              readonly
              formControlName="startTime"
            />
            <ngx-mat-timepicker
            #timepicker
            [enableKeyboardInput]="true">
          </ngx-mat-timepicker>
          
          
          
            <mat-icon
              matSuffix
              *ngIf="!formControlItem.disabled"
              (click)="openFromIcon(timepicker)"
              >schedule</mat-icon
            >

            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('sunday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('sunday')?.get('startTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>End Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="sundayEnd"
            [format]="24"
            readonly
            formControlName="endTime"
          />
          <ngx-mat-timepicker
          #sundayEnd
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(sundayEnd)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('sunday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('sunday')?.get('endTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </fxLayout>
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="monday"
          style="margin-bottom: 20px;align-items: baseline;">
          <h3 class="weekdate">Monday</h3>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Start Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="monStart"
            [format]="24"
            readonly
            formControlName="startTime"
          />
          <ngx-mat-timepicker
          #monStart
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(monStart)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('monday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('monday')?.get('startTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>End Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="monEnd"
            [format]="24"
            readonly
            formControlName="endTime"
          />
          <ngx-mat-timepicker
          #monEnd
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(monEnd)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('monday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('monday')?.get('endTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </fxLayout>
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="tuesday"
          style="margin-bottom: 20px;align-items: baseline;">
          <h3 class="weekdate">Tuesday</h3>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Start Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="tueStart"
            [format]="24"
            readonly
            formControlName="startTime"
          />
          <ngx-mat-timepicker
          #tueStart
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(tueStart)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('tuesday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('tuesday')?.get('startTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>End Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="tueEnd"
            [format]="24"
            readonly
            formControlName="endTime"
          />
          <ngx-mat-timepicker
          #tueEnd
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(tueEnd)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('tuesday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('tuesday')?.get('endTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </fxLayout>
        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="wednesday"
        style="margin-bottom: 20px;align-items: baseline;">
        <h3 class="weekdate">Wednesday</h3>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Start Time</mat-label>
        
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="wedStart"
          [format]="24"
          readonly
          formControlName="startTime"
        />
        <ngx-mat-timepicker
        #wedStart
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>
      
        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(wedStart)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('wednesday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('wednesday')?.get('startTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>End Time</mat-label>
        
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="wedEnd"
          [format]="24"
          readonly
          formControlName="endTime"
        />
        <ngx-mat-timepicker
        #wedEnd
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>
      
        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(wedEnd)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('wednesday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('wednesday')?.get('endTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        </fxLayout>

        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="thursday"
        style="margin-bottom: 20px;align-items: baseline;">
        <h3 class="weekdate">Thursday</h3>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Start Time</mat-label>
        
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="thurStart"
          [format]="24"
          readonly
          formControlName="startTime"
        />
        <ngx-mat-timepicker
        #thurStart
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>
      
        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(thurStart)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('thursday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('thursday')?.get('startTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>End Time</mat-label>
          
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="thurEnd"
          [format]="24"
          readonly
          formControlName="endTime"
        />
        <ngx-mat-timepicker
        #thurEnd
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>
      
        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(thurEnd)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('thursday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('thursday')?.get('endTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        </fxLayout>

        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="friday"
          style="margin-bottom: 20px;align-items: baseline;">
          <h3 class="weekdate">Friday</h3>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Start Time</mat-label>
            
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="friStart"
            [format]="24"
            readonly
            formControlName="startTime"
          />
          <ngx-mat-timepicker
          #friStart
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(friStart)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('friday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('friday')?.get('startTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>End Time</mat-label>
          
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="friEnd"
            [format]="24"
            readonly
            formControlName="endTime"
          />
          <ngx-mat-timepicker
          #friEnd
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!formControlItem.disabled"
            (click)="openFromIcon(friEnd)"
            >schedule</mat-icon
          >
            <mat-error
              *ngIf="partnerForm.controls['restrictedHours']?.get('friday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('friday')?.get('endTime')?.hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </fxLayout>

        <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" formGroupName="saturday"
        style="margin-bottom: 20px;align-items: baseline;">
        <h3 class="weekdate">Saturday</h3>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Start Time</mat-label>
          
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="satStart"
          [format]="24"
          readonly
          formControlName="startTime"
        />
        <ngx-mat-timepicker
        #satStart
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>

        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(satStart)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('saturday')?.get('startTime')?.touched && partnerForm.controls['restrictedHours']?.get('saturday')?.get('startTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>End Time</mat-label>
          
          <input
          type="text"
          matInput
          [ngxMatTimepicker]="satEnd"
          [format]="24"
          readonly
          formControlName="endTime"
        />
        <ngx-mat-timepicker
        #satEnd
        [enableKeyboardInput]="true">
      </ngx-mat-timepicker>

        <mat-icon
          matSuffix
          *ngIf="!formControlItem.disabled"
          (click)="openFromIcon(satEnd)"
          >schedule</mat-icon
        >
          <mat-error
            *ngIf="partnerForm.controls['restrictedHours']?.get('saturday')?.get('endTime')?.touched && partnerForm.controls['restrictedHours']?.get('saturday')?.get('endTime')?.hasError('required')">
            This is a required field.</mat-error>
        </mat-form-field>
        </fxLayout>
        </ng-container>
      </div>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button type="button" class="sub-button" (click)="add()">{{partnerId ? 'Update' :
          'Add'}}</button>
      </div>
      <!-- <div class="form-fld text-center" style="margin-top: 16px;">
        <div class="actionControl">
          <button type="button" class="submit-btn" (click)="add()"><span>{{partnerId ? 'Update' :
              'Add'}}</span></button>
        </div>
      </div> -->
    </form>
  </div>
</div>




  
